import { Component, Inject, inject, ViewChild } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatButton } from '@angular/material/button'
import { TranslateModule } from '@ngx-translate/core'
import { UserUploadedResource } from '../call-document-upload/call-document-upload.component'
import { CallsService } from '../calls.service'
import { LoggerService } from '../logger.service'
import { ToastService } from '../toast.service'
import { SpinnerComponent } from '../spinner/spinner.component'
import { FileUploadComponent } from '../file-upload/file-upload.component'
import { DocumentUploadInfo } from '../utils'
import { FileUploadType } from '../uploads.service'

export type DocumentUploadDialogInputData = { callId: number; title: string; documentToUpload: UserUploadedResource; type: FileUploadType }

@Component({
  selector: 'app-document-upload-dialog',
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, MatButton, TranslateModule, SpinnerComponent, FileUploadComponent],
  templateUrl: './document-upload-dialog.component.html',
  styleUrl: './document-upload-dialog.component.scss',
})
export class DocumentUploadDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DocumentUploadDialogInputData,
    private dialogRef: MatDialogRef<DocumentUploadDialogComponent>
  ) {}

  @ViewChild(FileUploadComponent)
  fileUploadComponent!: FileUploadComponent

  callsService = inject(CallsService)
  toastService = inject(ToastService)
  importResourceMutation = this.callsService.importResource()
  uploading = false
  uploadInfo: DocumentUploadInfo | null = null

  get acceptedExtensions() {
    return this.data.documentToUpload.extensions
  }

  get maxSize() {
    return this.data.documentToUpload.maxSize
  }

  get type() {
    return this.data.documentToUpload.uploadType
  }

  async onUploadClick() {
    this.uploading = true
    await this.importResourceMutation.mutateAsync({
      callId: this.data.callId,
      data: {
        fileType: this.data.documentToUpload.type,
        fileExtension: this.uploadInfo!.extension,
        uploadKey: this.uploadInfo!.key,
        fileName: this.uploadInfo!.fileName,
      },
    })
    this.uploading = false
    this.uploadInfo = null
    this.dialogRef.close(true)
  }
}
